module.exports = __webpack_public_path__ + "static/img/uidesignmobile.db382ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Pods/uidesignmobile.png
// module id = VWXa
// module chunks = 0